import type { LayoutProps as Props } from './types';
import { withChildren } from '@builder.io/react';
import { cls } from '@/utils/cls';
import style from './Layout.module.scss';
import FormSkeleton from '../Form/FormSkeleton';
export function Layout({
  extendStyles,
  children
}: Props) {
  if (!children || children.length === 0) {
    return <div>Please Add Some Child Components!</div>;
  }
  const _className = cls(style.root, extendStyles);
  const controlledComponents = ['Header', 'HeaderV2', 'Form', 'SingleForm', 'Hero', 'HeroWithImage', 'SecondaryHero', 'MainHeader', 'TrapezoidHero', 'ContactUs', 'BragBar'];

  // get the controlled components for the layout
  const header = children.find(e => e.props.block.component?.name === 'Header') || null;
  const headerV2 = children.find(e => e.props.block.component?.name === 'HeaderV2') || null;
  const mainHeader = children.find(e => e.props.block.component?.name === 'MainHeader') || null;
  const form = children.find(e => e.props.block.component?.name === 'Form') || null;
  const hero = children.find(e => e.props.block.component?.name === 'Hero') || null;
  const heroWithImage = children.find(e => e.props.block.component?.name === 'HeroWithImage') || null;
  const trapezoidHero = children.find(e => e.props.block.component?.name === 'TrapezoidHero') || null;
  const secondaryHero = children.find(e => e.props.block.component?.name === 'SecondaryHero') || null;
  const bragBar = children.find(e => e.props.block.component?.name === 'BragBar') || null;
  const contactUs = children.find(e => e.props.block.component?.name === 'ContactUs') || null;
  const IconList = children.find(e => e.props.block.component?.name === 'IconList' && e.props.block.component?.options.secondaryHeroLoc) || null;
  const LAYOUT_FORM_HEIGHT = 1350;

  // remove the controlled components for the rest of the page
  const filteredChildren = children.filter(e => {
    // might be duplicate of IconList, remove it
    if (e.props.block.id === IconList?.props.block.id) {
      return null;
    }
    return !controlledComponents.includes(e.props.block.component?.name ?? '');
  });
  return <main id="base" className={_className} data-sentry-component="Layout" data-sentry-source-file="Layout.tsx">
			{header || headerV2 || mainHeader}
			<section className={style.upper}>
				{hero || heroWithImage || trapezoidHero}
				{bragBar}
				{secondaryHero || IconList}
				{contactUs}
				{form && <FormSkeleton formHeight={LAYOUT_FORM_HEIGHT}>{form}</FormSkeleton>}
			</section>
			<section>{filteredChildren}</section>
		</main>;
}
export default withChildren(Layout);